<template>
  <div style="width:100% !important">
    <v-card max-width="500" flat color="#F3F5F8">
        <v-card-title>
          <h5 class="titleText--text font-weight-bold">{{ title }}</h5>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" width="50%">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" >
                <v-icon title="View Data" color="blue">mdi-cog</v-icon>
              </v-btn>
            </template>
  
            <v-card>
              <v-card-title>
                <span class="titleText--text font-weight-bold">{{ title }}</span>
                <v-spacer />
                <v-btn color="titleText" icon @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
                <v-simple-table fixed-header>
                     <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-center titleText--text font-weight-bold" style="background: #f7f8fa">Estimate</th>
                        <th class="text-center titleText--text font-weight-bold" style="background: #f7f8fa">Tvalue</th>
                        <th class="text-center titleText--text font-weight-bold" style="background: #f7f8fa">Decay</th>
                        <th class="text-center titleText--text font-weight-bold" style="background: #f7f8fa">TrigmaAI_Recommendation</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in options" :key="item.variable">
                        <td class="text-center titleText--text">{{ item.estimate }}</td>
                        <td class="text-center titleText--text">{{ item.tvalue }}</td>
                        <td class="text-center titleText--text">{{ item.decay }}</td>
                      <!--  <td class="text-center">{{ item.model_variable }}</td>-->
                        <td class="text-center font-weight-bold titleText--text">{{ item.TrigmaAI_Recommendation }}</td>
                      </tr>
                    </tbody>
                  </template>
                 
                </v-simple-table>
            </v-card>
          </v-dialog>
        </v-card-title>
        <v-card-text>
        <v-select
          hide-details="auto"
          style="border-radius: 8px; border: 2px solid #f3f5f8"
          dense
          solo
          flat
          class="mb-3 mx-0"
          v-model="optionsrecomend[0].decayselectednew"
          :items="list10_100"
          :label="optionsrecomend[0].variable"
          @change="savedata()"
        ></v-select>
        <span class="darkGrey--text font-weight-bold mx-1"> Recommended: {{optionsrecomend[0].decay}}</span>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
//import apifactory from "../api";
export default {
  props: {
    options: {
      type: [],
      required: true,
    },
    optionsrecomend: {
      type: [],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    ishavedata: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    list10_100: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    dialog: false,
    listforsave:[],
    selectedvalue:null,
  }),

  methods: {
    /*
      save_channel_decay(varregion,varparam){
        alert('call from ctrldecay')
          apifactory
        .callsave_channel_decay(varregion,varparam)
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
              // this.showmsghide=true;
              // this.listfind_decay=res.data;
            //alert( JSON.stringify(res.data));
          }
        })
        .catch(function (error) {
          alert(error);
          // return false;
        });
      },*/
       childMethod: function() {
          // this.selectedvalue = optionsrecomend[0].decayrecommanded;
          
      this.$emit('child-method', this.selectedvalue);
    },
        savedata(){
            this.selectedvalue=JSON.stringify(this. optionsrecomend);
            this.childMethod();
    //this.$parent.callfromchild("manish");
    //this.listforsave=[];
    //let dataforsave=new Object();
    //dataforsave[this.options.variable]=this.options.decay;
    //this.listforsave.push(dataforsave);
    /*if(this.listforsave != null){
       // this.save_channel_decay(this.options.region,JSON.stringify(this.listforsave));
        //let apiurl = "save_channel_decay/?project=50&region="+this.options.region+"&param="+JSON.stringify(this.listforsave)+"";
        //alert(apiurl);
    }*/
    //alert('dataforsave');
},

   filteredDatalist() {
      let templist = [];
      
templist=this.options.filter(a=>a.TrigmaAI_Recommendation == 'Recommended');
      return templist;
    },
  },
  computed: {
 
  },
};
</script>
<style>
.header-icon-space {
    padding-right: 10px !important;
}
.header-title-style {
    font-size: 12px !important;
}
</style>
